import React, { Component } from 'react'
import { FormattedMessage, injectIntl } from 'react-intl'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import _ from 'lodash'

import FinanceTable from '../FinanceTable'
import RadarGraph from './components/RadarGraph'

import { LOCALE_PREFIX } from './constants'
import hocConnect from './hocConnect'
import './style.scss'

@hocConnect
@injectIntl
export default class Fanal extends Component {
    static propTypes = {
        block: PropTypes.string.isRequired,
        customData: PropTypes.object,
        data: PropTypes.object,
        fanalChangeSelectedYear: PropTypes.func.isRequired,
        fanalToggleGraphTable: PropTypes.func.isRequired,
        id: PropTypes.string.isRequired,
        intl: PropTypes.object,
        level: PropTypes.string.isRequired,
        module: PropTypes.string.isRequired,
        selectedYear: PropTypes.number,
        showDataTable: PropTypes.bool,
    }

    constructor(props) {
        super(props)

        this.state = {
            termsExpanded: true,
        }
    }

    renameProperty = (oldProp, newProp, { [oldProp]: old, ...others }) => ({
        [newProp]: old,
        ...others,
    })

    handleClosableRowClick = () => {
        const { termsExpanded } = this.state

        this.setState({ termsExpanded: !termsExpanded })
    }

    handleToggleDataTable = (active) => {
        const { module, id, block, fanalToggleGraphTable, customData } = this.props

        const newCustomData = {
            ...customData,
            radarGraph: {
                ...customData.radarGraph,
                showDataTable: active,
            },
        }

        fanalToggleGraphTable(module, id, block, newCustomData)
    }

    handleChangeSelectedYear = (year) => {
        const { module, id, block, fanalChangeSelectedYear, customData } = this.props

        const newCustomData = {
            ...customData,
            radarGraph: {
                ...customData.radarGraph,
                selectedYear: year,
            },
        }

        fanalChangeSelectedYear(module, id, block, newCustomData)
    }

    render() {
        const { id, data, intl, level, showDataTable, selectedYear } = this.props
        const { termsExpanded } = this.state

        // Terms Explanation
        const termsExplanations = [
            { title: 'profitabilityTitle', text: 'profitabilityText' },
            { title: 'liquidityTitle', text: 'liquidityText' },
            { title: 'activityTitle', text: 'activityText' },
            { title: 'indebtednessTitle', text: 'indebtednessText' },
        ]

        const sectorData = _.reduce(
            _.get(data, 'sector'),
            (acc, val) => {
                const transformedVal = this.renameProperty('sectorAverage', 'values', val)

                return [...acc, transformedVal]
            },
            []
        )

        const transformedLevel = parseInt(level.split(',').slice(-1).pop(), 10)

        return (
            <div className={'financial-analysis-container'}>
                <div className={'finance-table-container'}>
                    <FinanceTable
                        id={`${id}`}
                        data={_.get(data, 'analysisData', [])}
                        isAdvanced={false}
                        sectionsDefinition={_.get(data, 'legend.sections', [])}
                        title={intl.formatMessage({ id: `${LOCALE_PREFIX}.firmPointers` })}
                        tableType={'analysis'}
                    />
                </div>
                {transformedLevel > 10 && (
                    <div className="finance-table-container">
                        <FinanceTable
                            id={`${id}`}
                            data={sectorData}
                            isAdvanced={false}
                            sectionsDefinition={_.get(data, 'legend.sections', [])}
                            title={intl.formatMessage({ id: `${LOCALE_PREFIX}.sectorPointers` })}
                            tableType={'analysis-sector'}
                        />
                    </div>
                )}
                <div className={'terms-explanation-container'}>
                    <div className={'closable-row'}>
                        <div
                            className={classnames('title', termsExpanded && 'expanded')}
                            onClick={() => this.handleClosableRowClick()}
                        >
                            <span className={'info-icon'} />
                            <span className={'title-text'}>
                                <FormattedMessage id={`${LOCALE_PREFIX}.termsExplanation`} />
                            </span>
                        </div>
                        {termsExpanded && (
                            <div className={'children'}>
                                {_.map(termsExplanations, (row, index) => (
                                    <div key={`terms-explanation-row-${index}`} className={'terms-explanation-row'}>
                                        <div className={'row-title'}>
                                            <FormattedMessage id={`${LOCALE_PREFIX}.${_.get(row, 'title', '')}`} />
                                        </div>
                                        <div className={'row-text'}>
                                            <FormattedMessage id={`${LOCALE_PREFIX}.${_.get(row, 'text', '')}`} />
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
                {transformedLevel > 10 && (
                    <div className={'radar-graph-container'}>
                        <RadarGraph
                            id={`finance-analysis-radar-graph-${id}`}
                            data={data}
                            showDataTable={showDataTable}
                            selectedYear={selectedYear}
                            handleToggleDataTable={this.handleToggleDataTable}
                            handleChangeSelectedYear={this.handleChangeSelectedYear}
                            translates={{
                                dataTable: intl.formatMessage({ id: `${LOCALE_PREFIX}.dataTable` }),
                                no: intl.formatMessage({ id: `${LOCALE_PREFIX}.no` }),
                                yes: intl.formatMessage({ id: `${LOCALE_PREFIX}.yes` }),
                                firm: intl.formatMessage({ id: `${LOCALE_PREFIX}.firm` }),
                                sector: intl.formatMessage({ id: `${LOCALE_PREFIX}.sector` }),
                                firmEvolution: intl.formatMessage({ id: `${LOCALE_PREFIX}.firmEvolution` }),
                                sectorEvolution: intl.formatMessage({ id: `${LOCALE_PREFIX}.sectorEvolution` }),
                                sectorAverage: intl.formatMessage({ id: `${LOCALE_PREFIX}.sectorAverage` }),
                                firmVersusSector: intl.formatMessage({ id: `${LOCALE_PREFIX}.firmVersusSector` }),
                                pointer: intl.formatMessage({ id: `${LOCALE_PREFIX}.pointer` }),
                                noComparisonGroup: intl.formatMessage({ id: `${LOCALE_PREFIX}.noComparisonGroup` }),
                                numberOfSubjects: intl.formatMessage({ id: `${LOCALE_PREFIX}.numberOfSubjects` }),
                                sectorNace: intl.formatMessage({ id: `${LOCALE_PREFIX}.sectorNace` }),
                                noGraphData: intl.formatMessage({ id: `${LOCALE_PREFIX}.noGraphData` }),
                            }}
                        />
                    </div>
                )}
            </div>
        )
    }
}
